import AnimatedNumber from '@components/Animation/AnimatedNumber';
import styled from '@emotion/styled';
import {colors} from '@styles/colors';
import {fontWeight, mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 40px;

  ${mq(Devices.laptop)}{
    padding-top: 20px;
  }

  ${mq(Devices.mobile)}{
    padding-top: 20px;
  }
`;